
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $i6Twd = parcelRequire("i6Twd");

var $5tlJV = parcelRequire("5tlJV");
new (0, $i6Twd.default)(".videos-swiper__container", {
    spaceBetween: 0,
    slidesPerView: 1.11,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    draggable: true,
    modules: [
        (0, $5tlJV.Navigation),
        (0, $5tlJV.Pagination)
    ],
    navigation: {
        nextEl: ".videos-swiper-button-next",
        prevEl: ".videos-swiper-button-prev"
    },
    pagination: {
        el: ".videos-swiper-pagination",
        type: "fraction",
        clickable: true
    },
    breakpoints: {
        768: {
            slidesPerView: 1.48,
            spaceBetween: 0
        }
    }
});
const $e9de0cd08b84a199$var$body = document?.querySelector('body');
const $e9de0cd08b84a199$var$playButtons = document?.querySelectorAll('.video-play-button');
const $e9de0cd08b84a199$var$closeButtons = document?.querySelectorAll('.swiper-close-vimeo-modal');
const $e9de0cd08b84a199$var$players = {};
const $e9de0cd08b84a199$var$playerIdentifiers = new Set();
const $e9de0cd08b84a199$var$toggleOpenCloseSwiperVideo = (currentPlayer)=>{
    const { videoContainer: videoContainer, player: player } = currentPlayer || {};
    $e9de0cd08b84a199$var$body?.classList?.toggle('overflow');
    videoContainer?.classList?.toggle('active');
    player?.getPaused()?.then(()=>{
        if (videoContainer?.classList?.contains('active')) {
            player?.play();
            player?.setMuted(false);
        } else {
            player?.setMuted(true);
            player?.pause();
        }
    });
};
if ($e9de0cd08b84a199$var$playButtons?.length > 0) {
    for(let i = 0; i < $e9de0cd08b84a199$var$playButtons.length; i++){
        const playerIdentifier = $e9de0cd08b84a199$var$playButtons[i]?.dataset?.playerId;
        $e9de0cd08b84a199$var$playerIdentifiers.add(playerIdentifier);
    }
    if ($e9de0cd08b84a199$var$playerIdentifiers?.size > 0) $e9de0cd08b84a199$var$playerIdentifiers.forEach((playerIdentifier)=>{
        const iframe = document.getElementById(playerIdentifier);
        const videoContainer = iframe?.closest('.swiper-vimeo-custom-video');
        $e9de0cd08b84a199$var$players[playerIdentifier] = {
            videoContainer: videoContainer,
            player: new Vimeo.Player(iframe)
        };
    });
    for(let i = 0; i < $e9de0cd08b84a199$var$playButtons.length; i++){
        const playerIdentifier = $e9de0cd08b84a199$var$playButtons[i]?.dataset?.playerId;
        $e9de0cd08b84a199$var$playButtons[i].addEventListener('click', ()=>$e9de0cd08b84a199$var$toggleOpenCloseSwiperVideo($e9de0cd08b84a199$var$players[playerIdentifier]));
    }
}
if ($e9de0cd08b84a199$var$closeButtons?.length > 0) for(let i = 0; i < $e9de0cd08b84a199$var$closeButtons.length; i++){
    const playerIdentifier = $e9de0cd08b84a199$var$closeButtons[i]?.dataset?.playerId;
    $e9de0cd08b84a199$var$closeButtons[i].addEventListener('click', ()=>$e9de0cd08b84a199$var$toggleOpenCloseSwiperVideo($e9de0cd08b84a199$var$players[playerIdentifier]));
}


//# sourceMappingURL=video-production.41f98b73.js.map
